<template>
  <div class="fm">
    <!-- <div class="fm__show">
      <RadioGroup
        v-model="dataDisplayType"
        @change="handleRadioChange"
      >
        <RadioButton label="1">表格展示</RadioButton>
        <RadioButton label="2">图表展示</RadioButton>
      </RadioGroup>
    </div> -->

    <!-- v-if="dataDisplayType === '1'" -->
    <Table
      v-loading="tableLoading"
      class="fm__table"
      border
      :data="tableData"
      :header-cell-style="tableHeaderStyle"
    >
      <TableColumn
        label="日期"
        prop="date"
        width="100px"
      />
      <TableColumn
        v-for="item in tableColumns"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :width="item.width"
        align="right"
      >
        <template slot-scope="scope">
          <TableCell :dataSource="scope" />
        </template>
      </TableColumn>
    </Table>

    <!-- <div v-if="dataDisplayType === '2'">
      <FieldSelect
        v-model="selectedFields"
        :options="fieldSelectOptions"
        @change="handleSelectChange"
      />
      <div class="fm__chart__list">
        <div
          v-for="key in selectedFields"
          :key="key"
          class="fm__chart__list--item"
        >
          <Chart
            :options="chartOptions"
            :dataSource="chartData[key]"
          />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import {
  // RadioGroup,
  // RadioButton,
  Table,
  TableColumn,
} from 'element-ui';

import TableCell from '../components/TableCell';
// import FieldSelect from '../components/FieldSelect';
// import Chart from '@/components/Chart/';

import Request from '@/core/QuRequest';
import columns from './columns';
import {
  createTableData,
  // createChartData
} from '../utils/formatData';
// import { formatValue } from '../utils/formatValue';
// import { localStorage } from '@/common/storage/';

const req = new Request();

// const LOCAL_STORAGE_KEY = 'MARKET-FLUCTUATIONS';
// const LOCAL_STORAGE_KEY_FIELD = `${LOCAL_STORAGE_KEY}-FULLMEDIA-FIELDS`;
// const LOCAL_STORAGE_KEY_TAB = `${LOCAL_STORAGE_KEY}-FULLMEDIA-TAB`;

export default {
  components: {
    // RadioGroup,
    // RadioButton,
    Table,
    TableColumn,

    TableCell,
    // FieldSelect,
    // Chart,
  },

  props: {
    date: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      tableData: [],
      tableColumns: columns,
      tableLoading: false,
    };
  },

  watch: {
    date() {
      this.updateData();
    },
  },

  created() {
    this.updateData();
  },

  methods: {
    updateData() {
      this.volatilityAllMediaDashboard();
    },

    // 全媒体大盘报表
    async volatilityAllMediaDashboard() {
      this.tableLoading = true;
      try {
        const params = {
          date: this.date[0].format('YYYY-MM-DD'),
          compare_date: this.date[1].format('YYYY-MM-DD'),
        };
        const res = await req.send(
          req.Apis.sales.report.volatilityAllMediaDashboard,
          params,
        );
        this.tableLoading = false;

        if (res && res.code === 200) {
          const data = createTableData(res.data);
          this.tableData = data;
        }
      } catch (err) {
        this.tableLoading = false;
        this.$message.error(err.message);
      }
    },

    tableHeaderStyle({ rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #F2F9FF';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.fm {
  margin-top: 24px;

  &__show {
    display: flex;
    justify-content: flex-end;
  }

  &__table {
    margin-top: 24px;
  }
}
</style>